import { type PayloadAction, createSlice } from "@reduxjs/toolkit"

export enum ModalType {
  NONE = "NONE",
  PROJECT_DELETE = "PROJECT_DELETE",
  REVOKE_API_KEY = "REVOKE_API_KEY",
  TEAM_INVITE_CREATE = "TEAM_INVITE_CREATE",
  TEAM_MEMBER_REMOVE = "TEAM_MEMBER_REMOVE",
  RELAY_UPDATE = "RELAY_UPDATE",
  RELAY_DELETE = "RELAY_DELETE",
  DNS_CREATE = "DNS_CREATE",
  DNS_UPDATE = "DNS_UPDATE",
  DNS_DELETE = "DNS_DELETE",
}

export type ModalAction = PayloadAction<{ modal: ModalType; data: any }>

export interface ModalAppState {
  modal: ModalType
  data: any
}

const initialState: ModalAppState = {
  modal: ModalType.NONE,
  data: "",
}

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    showModal: (state, action: ModalAction) => {
      state.modal = action.payload.modal
      state.data = action.payload?.data || ""
    },
    dismissModal: (state) => {
      state.modal = ModalType.NONE
      state.data = ""
    },
  },
})

export const { dismissModal } = modalSlice.actions
export const ModalReducer = modalSlice.reducer

export const showModal = (modal: ModalType, data?: any) =>
  modalSlice.actions.showModal({
    modal,
    data,
  })
